import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import EndorsementLicenceTypeForm from '../../../components/forms/EndorsementLicenceTypeForm';
import { useCreateEndorsementLicenceType } from '../../../hooks/useEndorsementLicenceTypeApi';
import { useNavigate } from 'react-router-dom';
import { EndorsementLicenceTypeDTO } from '../../../services/apiClient';

const EndorsementLicenceTypeCreate: React.FC = () => {
  const createMutation = useCreateEndorsementLicenceType();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    {
      label: 'Endorsement Licence Types',
      href: '/admin/endorsementlicencetypes',
    },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: EndorsementLicenceTypeDTO) => {
    try {
      await createMutation.mutateAsync(data);
      navigate('/admin/endorsementlicencetypes');
    } catch (error) {
      console.error('Error creating EndorsementLicenceType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/endorsementlicencetypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.EndorsementLicenceType.Edit"
    >
        <EndorsementLicenceTypeForm
          initialValues={{} as EndorsementLicenceTypeDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/endorsementlicencetypes')}
        />
    </AdminLayout>
  );
};

export default EndorsementLicenceTypeCreate;
